import { useState } from "react";
import { useParams } from "react-router";
import { Grid, Typography, MenuItem, Hidden, Button, Divider } from "@material-ui/core";
import CopyAssignmentModal from "../../../Modals/CopyAssignmentModal";
import DeleteAssignmentModal from "../../../Modals/DeleteAssignmentModal";
import ShareAssignmentModal from "../../../Modals/ShareAssignmentModal";
import OverflowMenuButton from "../../../OverflowMenuButton";
import AssignModal from "../../../Modals/AssignModal";
import useParamsSelector, { getAssignment } from "../../../../selectors";
import Trash from "../../../../assets/icons/noun_trash.png";
import Copy from "../../../../assets/icons/noun_copy_2953569.png";
import Share from "../../../../assets/icons/noun_Share_1736504.png";
import Eye from "../../../../assets/icons/noun_Eye_3907900.png";
import Ellipsis from "../../../../assets/icons/ellipsis.svg";
import "./styles.scss";
import { RootState } from "../../../../state/configureStore";

const editLink = (assignmentId: string, book?: string) =>
  `/teacher/#/assignment-control-center?stage=Intro&as=${assignmentId}${book ? `&book=${book}` : ""}`;

const ReportHeader = () => {
  const { assignmentId = "" } = useParams<{ assignmentId: string }>();
  const assignment = useParamsSelector(getAssignment)?.assignmentDetails;
  const currentUser = useParamsSelector((state: RootState) => state.currentUserState.currentUser);
  const book = assignment?.bookId;

  const [deleting, setDeleting] = useState(false);
  const [copying, setCopying] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [sharing, setSharing] = useState(false);
  const showModal = (setter: (v: boolean) => void) => () => {
    setter(true);
  };
  const showDeleteModal = showModal(setDeleting);
  const showCopyModal = showModal(setCopying);
  const showAssignModal = showModal(setAssigning);
  const showSharingModal = showModal(setSharing);
  const cancelClose = () => {
    setDeleting(false);
    setCopying(false);
    setAssigning(false);
    setSharing(false);
  };

  const isOwner = currentUser?.uid === assignment?.parentId;

  return (
    <div>
      <Grid container justifyContent="space-between" alignContent="center" wrap="nowrap">
        <p>ASSIGNMENT REPORT</p>
        <Button className="preview" href={`Book?assignmentid=${assignmentId}&classid=&isPreview=true`}>
          <img className="previewIcon" src={Eye} alt="" />
          <p className="previewText">Preview as Student</p>
        </Button>
      </Grid>
      <Grid className="ReportHeader" container justifyContent="space-between" alignContent="center" wrap="nowrap">
        <Typography className="assignmentTitle" variant="h3">
          {assignment?.title}
        </Typography>
        <Grid className="controls" container alignContent="center">
          <OverflowMenuButton
            buttonContents={<img src={Ellipsis} alt="Assignment Menu" />}
            className="overflowButton"
            variant="outlined"
          >
            <div className="reportOverflowMenu">
              <MenuItem onClick={showCopyModal}>
                <img className="overflowIcon" src={Copy} alt="" />
                Duplicate Assignment
              </MenuItem>
              <MenuItem disabled={!isOwner} onClick={showDeleteModal}>
                <img className="overflowIcon" src={Trash} alt="" />
                Delete Assignment
              </MenuItem>
              <MenuItem disabled={!isOwner} onClick={showSharingModal}>
                <img className="overflowIcon" src={Share} alt="" />
                Share with Teacher
              </MenuItem>
            </div>
          </OverflowMenuButton>
          <Button className="assignButton" variant="outlined" onClick={showAssignModal}>
            Assign
          </Button>
          {isOwner && (
            <a className="editButton" href={editLink(assignmentId, book)}>
              Edit <Hidden xsDown>Assignment</Hidden>
            </a>
          )}
          <DeleteAssignmentModal open={deleting} cancelClose={cancelClose} />
          <CopyAssignmentModal open={copying} cancelClose={cancelClose} />
          <AssignModal assignmentId={assignmentId} open={assigning} closeModal={cancelClose} />
          <ShareAssignmentModal open={sharing} cancelClose={cancelClose} />
        </Grid>
      </Grid>
      <Divider />
      <br />
      <br />
    </div>
  );
};

export default ReportHeader;
